/*
 * OASIS NATION — WebGL hero showpiece
 * Lightweight raw-WebGL flowing gold/green plasma behind the hero.
 * No external library. Falls back silently to the CSS aurora if WebGL
 * is unavailable or reduced-motion is requested.
 */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var hero = document.querySelector('.oasis-hero');
    if (!hero) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'oasis-hero__gl';
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return; // keep CSS aurora as fallback

    // Insert behind content, hide the CSS aurora blobs to avoid double-glow
    var overlay = hero.querySelector('.oasis-hero__overlay');
    if (overlay && overlay.parentNode) overlay.parentNode.insertBefore(canvas, overlay.nextSibling);
    else hero.appendChild(canvas);
    hero.classList.add('oasis-hero--gl');

    var vert = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.0,1.0);}';
    var frag = [
      'precision highp float;',
      'uniform vec2 u_res; uniform float u_time; uniform vec2 u_mouse;',
      'float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
      'float noise(vec2 p){vec2 i=floor(p);vec2 f=fract(p);f=f*f*(3.0-2.0*f);',
      'float a=hash(i);float b=hash(i+vec2(1.0,0.0));float c=hash(i+vec2(0.0,1.0));float d=hash(i+vec2(1.0,1.0));',
      'return mix(mix(a,b,f.x),mix(c,d,f.x),f.y);}',
      'float fbm(vec2 p){float v=0.0;float a=0.5;for(int i=0;i<5;i++){v+=a*noise(p);p*=2.0;a*=0.5;}return v;}',
      'void main(){',
      'vec2 uv=gl_FragCoord.xy/u_res.xy;',
      'vec2 p=uv*vec2(u_res.x/u_res.y,1.0)*2.6;',
      'float t=u_time*0.05;',
      'vec2 m=(u_mouse-0.5)*0.5;',
      'float n=fbm(p+vec2(t,-t)+m);',
      'n=fbm(p+n*1.4+vec2(-t,t*0.8));',
      'vec3 green=vec3(0.075,0.231,0.145);',
      'vec3 gold=vec3(0.804,0.647,0.243);',
      'vec3 col=mix(green,gold,smoothstep(0.38,0.78,n));',
      'float vig=smoothstep(1.15,0.15,length(uv-0.5));',
      'col*=vig;',
      'float alpha=(n*0.55+0.12)*vig;',
      'gl_FragColor=vec4(col,alpha);',
      '}'
    ].join('');

    function compile(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { return null; }
      return s;
    }
    var vs = compile(gl.VERTEX_SHADER, vert), fs = compile(gl.FRAGMENT_SHADER, frag);
    if (!vs || !fs) { canvas.remove(); hero.classList.remove('oasis-hero--gl'); return; }
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { canvas.remove(); hero.classList.remove('oasis-hero--gl'); return; }
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var uRes = gl.getUniformLocation(prog, 'u_res');
    var uTime = gl.getUniformLocation(prog, 'u_time');
    var uMouse = gl.getUniformLocation(prog, 'u_mouse');

    var mouse = [0.5, 0.5], tMouse = [0.5, 0.5], dpr = Math.min(window.devicePixelRatio || 1, 1.5);

    function resize() {
      var w = hero.clientWidth, h = hero.clientHeight;
      canvas.width = Math.floor(w * dpr); canvas.height = Math.floor(h * dpr);
      canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
      gl.viewport(0, 0, canvas.width, canvas.height);
    }
    resize();
    window.addEventListener('resize', resize);

    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      tMouse[0] = (e.clientX - r.left) / r.width;
      tMouse[1] = 1.0 - (e.clientY - r.top) / r.height;
    });

    var running = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { running = es[0].isIntersecting; if (running) requestAnimationFrame(loop); })
        .observe(hero);
    }

    var start = null;
    function loop(ts) {
      if (start === null) start = ts;
      mouse[0] += (tMouse[0] - mouse[0]) * 0.05;
      mouse[1] += (tMouse[1] - mouse[1]) * 0.05;
      gl.uniform2f(uRes, canvas.width, canvas.height);
      gl.uniform1f(uTime, (ts - start) / 1000);
      gl.uniform2f(uMouse, mouse[0], mouse[1]);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      if (running) requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
